module.exports = __webpack_public_path__ + "static/media/mariam-bio.ed99f8cc.pdf";